'use client';

import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';
import { useState } from 'react';

import { normalizeLocale } from '@/features/i18n/lib/config';
import type { Locale } from '@/features/i18n/types';

export function NotFoundContent() {
  const router = useRouter();
  const pathname = usePathname();
  // A 404 outside /en or /es (e.g. /wp-admin) has no locale segment; normalize it
  // instead of indexing the dictionary with an arbitrary path segment.
  const [locale, setLocale] = useState<Locale>(normalizeLocale(pathname?.split('/')[1]));
  const dictionary = {
    es: {
      'notFound.title': 'Página no encontrada',
      'notFound.description': 'La página que estás buscando no existe.',
      'notFound.goDashboard': 'Go to dashboard',
      'notFound.goHome': 'Go to home',
      'notFound.goBack': 'Go back',
    },
    en: {
      'notFound.title': 'Page not found',
      'notFound.description': 'The page you are looking for does not exist.',
      'notFound.goDashboard': 'Go to dashboard',
      'notFound.goHome': 'Go to home',
      'notFound.goBack': 'Go back',
    },
  };
  return (
    <>
      <div className="text-2xl font-semibold">{dictionary[locale]['notFound.title']}</div>
      <div className="text-neutral-600">{dictionary[locale]['notFound.description']}</div>
      <div className="flex items-center justify-center gap-3">
        <button
          className="px-4 py-2 rounded-md border border-neutral-300"
          onClick={() => router.back()}
        >
          {dictionary[locale]['notFound.goBack']}
        </button>
        <Link className="px-4 py-2 rounded-md border border-neutral-300" href={`/${locale}/`}>
          {dictionary[locale]['notFound.goHome']}
        </Link>
        <select
          className="px-4 py-2 rounded-md border border-neutral-300"
          onChange={(e) => {
            const value = e.target.value;
            if (value) {
              setLocale(value as Locale);
            }
          }}
          defaultValue={locale}
        >
          <option value="es">ES</option>
          <option value="en">EN</option>
        </select>
      </div>
    </>
  );
}
